module.exports = __webpack_public_path__ + "static/media/ind6kz.f9a5f6e6.pdf";